// @flow

import { initPhoneMaskModule } from 'common/phone-mask'
import { FsdvSlider } from 'common/slider-feedback'

import { SLIDER_CONFIG } from '../../data'

import { submitFormOlympHome } from './actions/submit-form-olymp-home'

export default () => {
  initPhoneMaskModule()

  new FsdvSlider('[data-slider]', SLIDER_CONFIG)

  document.querySelector('form')?.addEventListener('submit', submitFormOlympHome)
}
